import React from "react";
import "../../../styles/notFound.css";

const NotFound = () => {
  return (
    <div>
      <div className="row pt-5">
        <div className="col-md-3"></div>
        <div className="col-md-6" style={{ textAlign: "center" }}>
          <span className="appkiticon icon-alert-fill no-access-icon" />
        </div>
        <div className="col-md-3"></div>
      </div>
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6" style={{ textAlign: "center" }}>
          <div className="noaccess_heading">
            <p className="noaccess_header mt-3 mb-2">{404}</p>
            <p className="noaccess_header mt-3 mb-2">
              {"Oops! Sorry we can't find the page you're looking for"}
            </p>
          </div>
        </div>
        <div className="col-md-3"></div>
      </div>
    </div>
  );
};

export default NotFound;
